import { required, integer } from '@vuelidate/validators'

export const ListActionsValidation = {
    name: { required },
    description: { required },

    salary_from: { integer },
    salary_to: { integer },

    category_id: { required, integer },
    experience_id: { required, integer },
    region_id: { required, integer },
}
